export const accounts = {
  'Accounts.Title': 'Dine avtaler',
  'Accounts.Description': 'Trykk på en avtale for mer informasjon.',
  'Accounts.Error': 'Det oppstod en feil ved innlasting av avtaler.',
  'Accounts.Archive.Title': 'Avsluttede avtaler',
  'Accounts.Archive.Description': 'Trykk på en avtale for mer informasjon.',
  'Accounts.Filter.NoMoreResults': 'Ingen flere avtaler å vise.',
  'Accounts.Filter.AdjustFilters': 'Juster filtrene for å se flere resultater.',
  'Accounts.Filter.SearchPlaceholder': 'Søk i avtaler...',
  'Accounts.Filter.Cancel': 'Avbryt',
  'Accounts.Filter.ApplySort': 'Bruk sortering',
  'Accounts.Filter.ApplyFilter': 'Bruk filter',
  'Accounts.Filter.Product': 'Produkt',
  'Accounts.Filter.Filter': 'Filter',
  'Accounts.Filter.Sort': 'Sorter',
};
